import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { COMPETITION_URL } from 'app/@common/constants'


export default function SelectDateRange({ ...props }) {

    const myProps = {
        urlAjax: COMPETITION_URL.DATE_RANGE,
        placeholder: 'Filter by date',
        icon: { icon: 'calendar' },
        firstSelect: true,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}